import { Fragment } from "react";
import partnerLogo from "../images/tdusa_logo_white.png";
import hdLogo from "../images/hd-logo-white.png";

export function BrandLockup() {

    return (
        <Fragment>
            <div className="Brand-Lockup">
                <div className="Primary-Brand">
                <img src={hdLogo} className="HDLogo" alt="Hawkin Dynamics" />
                </div>
                {/* <div className="Lockup-X">x</div> */}
                <div className="Secondary-Brand">
                    <img
                        src={partnerLogo}
                        className="Partner-Logo"
                        alt="Partner Logo"
                    />
                </div>
            </div> 
        </Fragment>
    );
}